module.exports = __webpack_public_path__ + "img/Slide_3.8a11bfcd.jpg";